import { useState } from "react"
import InputValidate from "../../components/InputValidate";
import UtilFunctions from "../../Utils/UtilFucntion";
import { Button } from "@mui/material";
import AxiosClient from "../../api/AxiosClient";

export default function ForgotPassword() {
    const [email, setEmail] = useState<string>('');
    const [success, setSuccess] = useState<boolean>(false);

    function onChangeData(name: string, value: string): void {
        setEmail(value);
    }

    function submit(): void {
        AxiosClient.post('forgot-password', {
            email: email
        }).then(() => {
            UtilFunctions.showToastSuccess('Gửi email thành công!');
        }).catch((e) => {
            UtilFunctions.showToastError('Đã có lỗi xảy ra');
        })
    }

    return (
        <div className="register-form">
            <div className="login-title">
                <div className="login-title--title">Quên mật khẩu</div>
                <div className="login-title--description">Nhập email tài khoản để tạo mới mật khẩu</div>
            </div>
            <div className="form-main mt-8">
                <InputValidate label={"Email"} name={""} onChangeData={onChangeData} value={email} isValid={UtilFunctions.isValidEmail(email)} alert={"Vui lòng nhập email hợp lệ"} disabled={false} placeholder={""} type={""} />
            </div>
            <div className="flex justify-end w-full mt-8">
                <Button variant="contained" onClick={submit} disabled={!UtilFunctions.isValidEmail(email)}>Xác nhận</Button>
            </div>
        </div>
    )
}